const agv = new URL('../../icons/agv.png', import.meta.url).href

export default {
  type: 'AGV',
  description: 'Auto Guided Vehicle',
  icon: agv,
  group: 'ACS',
  model: {
    type: 'AGV',
    left: 100,
    top: 100,
    width: 20,
    height: 20
  }
}
